/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { useRefreshProgressCheckData } from "@hooks/data/useRefreshProgressCheckData";
import { EventRegister } from "react-native-event-listeners";
import { ISubscriptionModalType } from "@interfaces/Interfaces";
import { useRefreshUserDetails } from "@hooks/data/useRefreshUserDetails";

type Props = {
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setModalType: React.Dispatch<React.SetStateAction<ISubscriptionModalType>>;
};

const AppEventListener: React.FC<Props> = (props) => {
  const { refreshUserDetails } = useRefreshUserDetails();
  const { refreshProgressCheckData } = useRefreshProgressCheckData();

  useEffect(() => {
    EventRegister.addEventListener("subscriptions/show-modal", (modalType: ISubscriptionModalType) => {
      props.setModalVisible(true);
      props.setModalType(modalType);
    });

    return () => {
      EventRegister.removeEventListener("subscriptions/show-modal");
    };
  }, []);

  useEffect(() => {
    EventRegister.addEventListener("subscriptions/refresh-user", (_user) => refreshUserDetails(_user));

    return () => {
      EventRegister.removeEventListener("subscriptions/refresh-user");
    };
  }, [refreshUserDetails]);

  useEffect(() => {
    EventRegister.addEventListener("comments/comment-sent", (_user) => refreshProgressCheckData(_user));
    EventRegister.addEventListener("comments/read-time-updated", (_user) => refreshProgressCheckData(_user));
    EventRegister.addEventListener("progress-check/submitted", (_user) => refreshProgressCheckData(_user));
    EventRegister.addEventListener("progress-check/created", (_user) => refreshProgressCheckData(_user));

    return () => {
      EventRegister.removeEventListener("comments/comment-sent");
      EventRegister.removeEventListener("comments/read-time-updated");
      EventRegister.removeEventListener("progress-check/submitted");
      EventRegister.removeEventListener("progress-check/created");
    };
  }, [refreshProgressCheckData]);

  return null;
};

export default AppEventListener;
